import { render, staticRenderFns } from "./ComponentScipInformation.vue?vue&type=template&id=66ef6308&"
import script from "./ComponentScipInformation.vue?vue&type=script&lang=js&"
export * from "./ComponentScipInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports